import type { WavespeedModelConfig } from '../types';
import { clampTo, hasImageInput, resolveImageSize } from '../../tools';

export const fluxConfigs: Record<string, WavespeedModelConfig> = {
    'wavespeed-ai/flux-2-flex/text-to-image': {
        // https://wavespeed.ai/zh-CN/models/wavespeed-ai/flux-2-flex/text-to-image
        apiPath: '/wavespeed-ai/flux-2-flex/text-to-image',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, aspectRatio, providerOptions } = params;
            return {
                prompt: prompt,
                size: resolveImageSize(
                    clampTo(aspectRatio || '16:9', ['16:9', '9:16', '4:3', '3:4', '3:2', '2:3', '1:1'] as const, '16:9'), 'standard'),
                seed: typeof providerOptions?.seed === 'number' ? providerOptions.seed : undefined,
            };
        },
    },
    'wavespeed-ai/flux-2-flex/edit': {
        // https://wavespeed.ai/zh-CN/models/wavespeed-ai/flux-2-flex/edit
        apiPath: '/wavespeed-ai/flux-2-flex/edit',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, image_urls, aspectRatio, providerOptions } = params;
            const images = image_urls.slice(0, 3);
            return {
                prompt: prompt,
                size: aspectRatio === 'match' ? undefined : resolveImageSize(
                    clampTo(aspectRatio || '16:9', ['16:9', '9:16', '4:3', '3:4', '3:2', '2:3', '1:1'] as const, '16:9'), 'standard'),
                seed: typeof providerOptions?.seed === 'number' ? providerOptions.seed : undefined,
                // 图片 URL
                images: images,
            };
        },
    },
    'wavespeed-ai/flux-2-max/text-to-image': {
        // https://wavespeed.ai/zh-CN/models/wavespeed-ai/flux-2-max/text-to-image
        apiPath: '/wavespeed-ai/flux-2-max/text-to-image',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, aspectRatio, providerOptions } = params;
            return {
                prompt: prompt,
                size: resolveImageSize(
                    clampTo(aspectRatio || '16:9', ['16:9', '9:16', '4:3', '3:4', '3:2', '2:3', '1:1'] as const, '16:9'), 'standard'),
                seed: typeof providerOptions?.seed === 'number' ? providerOptions.seed : undefined,
            };
        },
    },
    'wavespeed-ai/flux-2-max/edit': {
        // https://wavespeed.ai/zh-CN/models/wavespeed-ai/flux-2-max/edit
        apiPath: '/wavespeed-ai/flux-2-max/edit',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, image_urls, aspectRatio, providerOptions } = params;
            const images = image_urls.slice(0, 3);
            return {
                prompt: prompt,
                size: aspectRatio === 'match' ? undefined : resolveImageSize(
                    clampTo(aspectRatio || '16:9', ['16:9', '9:16', '4:3', '3:4', '3:2', '2:3', '1:1'] as const, '16:9'), 'standard'),
                seed: typeof providerOptions?.seed === 'number' ? providerOptions.seed : undefined,
                // 图片 URL
                images: images,
            };
        },
    },
    'wavespeed-ai/flux-2-pro/text-to-image': {
        // https://wavespeed.ai/zh-CN/models/wavespeed-ai/flux-2-pro/text-to-image
        apiPath: '/wavespeed-ai/flux-2-pro/text-to-image',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, aspectRatio, providerOptions } = params;
            return {
                prompt: prompt,
                size: resolveImageSize(
                    clampTo(aspectRatio || '16:9', ['16:9', '9:16', '4:3', '3:4', '3:2', '2:3', '1:1'] as const, '16:9'), 'standard'),
                seed: typeof providerOptions?.seed === 'number' ? providerOptions.seed : undefined,
            };
        },
    },
    'wavespeed-ai/flux-2-pro/edit': {
        // https://wavespeed.ai/zh-CN/models/wavespeed-ai/flux-2-pro/edit
        apiPath: '/wavespeed-ai/flux-2-pro/edit',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, image_urls, aspectRatio, providerOptions } = params;
            const images = image_urls.slice(0, 3);
            return {
                prompt: prompt,
                size: aspectRatio === 'match' ? undefined : resolveImageSize(
                    clampTo(aspectRatio || '16:9', ['16:9', '9:16', '4:3', '3:4', '3:2', '2:3', '1:1'] as const, '16:9'), 'standard'),
                seed: typeof providerOptions?.seed === 'number' ? providerOptions.seed : undefined,
                // 图片 URL
                images: images,
            };
        },
    },
    'wavespeed-ai/flux-2-klein-4b/text-to-image': {
        // https://wavespeed.ai/zh-CN/models/wavespeed-ai/flux-2-klein-4b/text-to-image
        apiPath: '/wavespeed-ai/flux-2-klein-4b/text-to-image',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, aspectRatio, providerOptions } = params;
            return {
                prompt: prompt,
                size: resolveImageSize(
                    clampTo(aspectRatio || '16:9', ['16:9', '9:16', '4:3', '3:4', '3:2', '2:3', '1:1'] as const, '16:9'), 'standard'),
                seed: typeof providerOptions?.seed === 'number' ? providerOptions.seed : undefined,
            };
        },
    },
    'wavespeed-ai/flux-2-klein-4b/edit': {
        // https://wavespeed.ai/zh-CN/models/wavespeed-ai/flux-2-klein-4b/edit
        apiPath: '/wavespeed-ai/flux-2-klein-4b/edit',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, image_urls, aspectRatio, providerOptions } = params;
            const images = image_urls.slice(0, 3);
            return {
                prompt: prompt,
                size: aspectRatio === 'match' ? undefined : resolveImageSize(
                    clampTo(aspectRatio || '16:9', ['16:9', '9:16', '4:3', '3:4', '3:2', '2:3', '1:1'] as const, '16:9'), 'standard'),
                seed: typeof providerOptions?.seed === 'number' ? providerOptions.seed : undefined,
                // 图片 URL
                images: images,
            };
        },
    },
    'wavespeed-ai/flux-2-klein-9b/text-to-image': {
        // https://wavespeed.ai/zh-CN/models/wavespeed-ai/flux-2-klein-9b/text-to-image
        apiPath: '/wavespeed-ai/flux-2-klein-9b/text-to-image',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, aspectRatio, providerOptions } = params;
            return {
                prompt: prompt,
                size: resolveImageSize(
                    clampTo(aspectRatio || '16:9', ['16:9', '9:16', '4:3', '3:4', '3:2', '2:3', '1:1'] as const, '16:9'), 'standard'),
                seed: typeof providerOptions?.seed === 'number' ? providerOptions.seed : undefined,
            };
        },
    },
    'wavespeed-ai/flux-2-klein-9b/edit': {
        // https://wavespeed.ai/zh-CN/models/wavespeed-ai/flux-2-klein-9b/edit
        apiPath: '/wavespeed-ai/flux-2-klein-9b/edit',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, image_urls, aspectRatio, providerOptions } = params;
            const images = image_urls.slice(0, 3);
            return {
                prompt: prompt,
                size: aspectRatio === 'match' ? undefined : resolveImageSize(
                    clampTo(aspectRatio || '16:9', ['16:9', '9:16', '4:3', '3:4', '3:2', '2:3', '1:1'] as const, '16:9'), 'standard'),
                seed: typeof providerOptions?.seed === 'number' ? providerOptions.seed : undefined,
                // 图片 URL
                images: images,
            };
        },
    },
};